import React from "react"
import { graphql, StaticQuery } from "gatsby"
import styled from 'styled-components'

import Layout from "../components/layout"
import SEO from "../components/seo"
import BackgroundImage from "gatsby-background-image"
import Logo from "../images/logo.svg"

const IndexPage = () => (
  <StaticQuery query={graphql`
    query {
      desktop: file(relativePath: { eq: "alarm-clock.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 4160) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      },
    }
  `}
   render={data => {
     const imageData = data.desktop.childImageSharp.fluid
     return (
       <Layout>
         <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
         <div className={"w-full bg-white flex flex-wrap lg:flex-row"}>
           <div className={"p-12 lg:p-16 w-full lg:w-45"}>
             <div className={"flex items-middle lg:flex-col"}>
               <StyledLogo1 className={"-ml-2 lg:mb-4"}/>
               <h1 className={"ml-2 lg:ml-0 text-3xl font-secondary"}>
                 <span className={"text-grey-dark"}>We are</span> checkthis
               </h1>
             </div>
             <p className={"my-6 lg:my-12 xl:w-70 text-grey-dark leading-normal"}>
               Welcome back, please login to your account.
             </p>
             <form>
               <input
                 className={"border p-4 block w-full mt-4 outline-none focus:border-grey-dark"}
                 type="text"
                 placeholder={'Email Address'}/>
               <input
                 className={"border p-4 block w-full my-4 outline-none focus:border-grey-dark"}
                 type="text"
                 placeholder={'Password'}/>
               <div className={"mt-6 lg:mt-12 flex flex-wrap items-center justify-between"}>
                 <label className={"inline-block pb-2"}>
                   <input className={"mr-2"} type="checkbox"/>
                   <span className={"text-sm text-grey-dark select-none"}>Remember me</span>
                 </label>
                 <span className={"text-sm block lg:inline-block pb-2"}>
                  Forgot password?
                </span>
               </div>
               <div className={"mt-6 lg:mt-12"}>
                 <button
                   className={`
                    rounded 
                    bg-black 
                    text-white 
                    px-12 
                    mr-8 
                    py-3 
                    text-sm 
                    font-secondary 
                    mb-4 
                    xl:mb-0
                    hover:bg-grey-darkest
                    animate
                   `}>
                   Login
                 </button>
                 <button
                   className={`
                    rounded 
                    border 
                    text-grey-darkest 
                    px-12 
                    py-3 
                    text-sm 
                    font-secondary 
                    hover:bg-grey-light
                    animate
                   `}>
                   Sign up
                 </button>
               </div>
               <div className={"mt-12"}>
                 <p className={"tracking-wide text-xs font-secondary text-grey-darkest"}>
                   By signing up, you agree to Checkthis's
                   &nbsp;<a className={"text-black hover:text-grey-darkest font-bold"} href="/">Terms and Conditions</a>
                   &nbsp;& <a className={"text-black hover:text-grey-darkest font-bold"} href="/"> Privacy Policy</a>
                 </p>
               </div>
             </form>
           </div>
           <div className={"hidden lg:block lg:w-55"}>
             <StyledBackgroundImage Tag="div" fluid={imageData}>
               <div className={"p-12 flex justify-center items-center h-full"}>
                 <StyledGradient className={"rounded-xl opacity-75"} />
                 <StyledColour className={"rounded-xl"} />
                 <StyledLogo2 />
               </div>
             </StyledBackgroundImage>
           </div>
         </div>
       </Layout>
     )
   }}
 />
)

const StyledGradient = styled.div`
  background: #3d4852;
  background: -moz-linear-gradient(top, #3d4852 0%, #606f7b 4%, #8795a1 50%, #606f7b 81%, #606f7b 81%, #3d4852 100%);
  background: -webkit-linear-gradient(top, #3d4852 0%,#606f7b 4%,#8795a1 50%,#606f7b 81%,#606f7b 81%,#3d4852 100%);
  background: linear-gradient(to bottom, #3d4852 0%,#606f7b 4%,#8795a1 50%,#606f7b 81%,#606f7b 81%,#3d4852 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3d4852', endColorstr='#3d4852',GradientType=0 );
  height: 200px;
  width: 200px;
`

const StyledColour = styled.div`
  height: 200px;
  width: 200px;
  position: absolute;
  background-color: white;
  opacity: 0.5;
`
const StyledLogo1 = styled(Logo)`
  height: 40px;
  width: 40px;
  & path {
    fill: #22292f;
  }
`

const StyledLogo2 = styled(Logo)`
  height: 160px;
  width: 160px;
  position: absolute;
  & path {
    fill: #22292f;
  }
`

const StyledBackgroundImage = styled(BackgroundImage)`
  height: 100%;
`

export default IndexPage
